/**
 * Base class for all API errors. Provides a statusCode for programmatic
 * handling without string matching on error messages.
 */
export class ApiError extends Error {
  public readonly statusCode: number;

  constructor(message: string, statusCode: number) {
    super(message);
    this.name = 'ApiError';
    this.statusCode = statusCode;
  }
}

/**
 * Thrown when the API returns a 404 Not Found response.
 * Includes an optional resourceType for context (e.g. "Account", "Snapshot").
 */
export class NotFoundError extends ApiError {
  public readonly resourceType?: string;

  constructor(message: string, resourceType?: string) {
    super(message, 404);
    this.name = 'NotFoundError';
    this.resourceType = resourceType;
  }
}

/**
 * Thrown when the API returns a 401 Unauthorized or 403 Forbidden response.
 */
export class AuthenticationError extends ApiError {
  constructor(message: string, statusCode: 401 | 403 = 401) {
    super(message, statusCode);
    this.name = 'AuthenticationError';
  }
}
